export const mediaUrl = "https://media.wheretomine.io"